import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PolygonDrawComponent } from './polygon-draw.component';

import { GoogleMapsModule } from '@angular/google-maps';
import { MaterialModule } from '../material.module';
import { PolygonosComponent } from './polygonos/polygonos.component';
import { RouterModule } from '@angular/router';
import { PivotComponent } from './pivot/pivot.component';

@NgModule({
  declarations: [PolygonDrawComponent, PolygonosComponent, PivotComponent],
  imports: [CommonModule, GoogleMapsModule, MaterialModule, RouterModule],
  exports: [PolygonDrawComponent],
})
export class PolygonDrawModule {}
